
    import '/home/ec2-user/Youlify-Design/CHANGELOG.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__CHANGELOG.zh-CN.md__zh-CN" */'/home/ec2-user/Youlify-Design/CHANGELOG.zh-CN.md?type=demo')
};